Array.from(document.getElementsByClassName("bwd-timeline")).forEach((cmp) => {
  Array.from(cmp.getElementsByClassName("bwd-timeline__timeline")[0].children).forEach((child, i, children) => {
    const fr = i / (children.length - 1);
    child.getElementsByClassName("bwd-timeline__item__marker")[0].style.top = `calc(${fr * 100}% - ${fr * 16}px)`;
  });
});
